import React, { useState, useEffect } from 'react';

import './styles.css';

import academyServices from '../../../services/academy/academyServices';
import loadTextTest from '../../../functions/loadTextTest';

import MainView from '../../../components/MainView';
import HomeCard from '../../../components/HomeCard';
import UserPhoto from '../../../components/UserPhoto';
import { FaUsers, FaUser, FaFutbol } from 'react-icons/fa';

export default function Home(props) {
    const [academyInfos, setAcademyInfos] = useState({});

    useEffect(() => {
        getAcademyInfos();    
    }, []);
    
    async function getAcademyInfos() {
        const response = await academyServices.getAcademyInfos();
        if(response.status === 200) {
            setAcademyInfos(response.data);
            localStorage.setItem("_academyInfos", JSON.stringify(response.data));
        } else
            alert("Erro ao ler informações da academia, tente novamente!");
    };

    return (
        <MainView currentPage='home' coachMenu>
            <div className='coach-home-page-message'>
                <h2>Bem vindo ao</h2>
                <h1>PORTAL <b>Boston</b>City</h1>
            </div>
            <hr />
            <div className='coach-home-page-user'>
                <div className='coach-home-page-user-infos'>
                    <UserPhoto src={academyInfos.logo}/>
                    <div className='coach-home-page-user-infos-texts'>
                        <h3>{"Professor"}</h3>
                        <p>{loadTextTest(academyInfos.cidade)}</p>
                    </div>
                </div>
                {/* <div className='coach-home-page-user-options'>
                    <Link to='/academia/documentos' className='button'>Documentos <FaRegFileAlt /></Link>
                </div> */}
            </div>
            <div className='coach-home-page-cards'>
                <HomeCard to='/professor/treinos' title={<><b>Treinos</b> hoje</>} data={loadTextTest(academyInfos.treinos_hoje)} icon={<FaFutbol />} />
                <HomeCard to='/professor/turmas' title={<><b>Turmas</b> ativas</>} data={loadTextTest(academyInfos.turmas)} icon={<FaUsers />} />
                <HomeCard to='/professor/alunos?ativos' title={<><b>Alunos</b> ativos</>} data={loadTextTest(academyInfos.alunos_ativos)} icon={<FaUser />} />
            </div>
        </MainView>
    )
}